<template>
  <component :is="layout"></component>
</template>

<script>
import DefaultLayout from './layouts/Default'
import PaigeDashboard from './layouts/PaigeDashboard'
import GroupOrderLayout from './layouts/GroupOrderLayout'
import AddressCollection from './layouts/AddressCollection'

export default {
  name: 'App',
  computed: {
    layout() {
      return this.$store.getters['layout/getLayout']
    }
  },
  components: {
    'default-layout': DefaultLayout,
    'paige-dashboard': PaigeDashboard,
    'group-order-layout': GroupOrderLayout,
    'address-collection': AddressCollection
  },
  beforeCreate() {
    const existingSession = window.$cookies.get('dashboard-session')
    if (existingSession) {
      this.$store.dispatch('auth/setHeaders', existingSession.tokens)
    }
  }
}
</script>

<style lang="scss">
@import 'global.scss';
#app {
  text-align: center;
}
</style>
